'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (feis) {
  var days = [];
  var feisDtStart = (0, _moment2.default)(feis.dt_start).tz(feis.tz).startOf('day');
  var feisDtEnd = (0, _moment2.default)(feis.dt_end).tz(feis.tz).startOf('day');
  var numDays = feisDtEnd.diff(feisDtStart, 'days') + 1;

  for (var i = 0; i < numDays; i++) {
    var date = feisDtStart.clone().add(i, 'd');
    days.push({
      date: date.valueOf(),
      title: date.format('MMM D')
    });
  }

  return days;
};


//////////////////
// WEBPACK FOOTER
// ./util/getFeisDays.js
// module id = 147
// module chunks = 0